import { useEffect } from "react";
import { useLocation } from "wouter";
import { getConsent, subscribeConsent } from "@/lib/analytics/consent";
import { isAutomatedBrowser } from "@/lib/analytics/automation";
import { track } from "@/lib/analytics";
const landed=new Set<string>();
export function useAgentHandoff() {
  const [location]=useLocation();
  useEffect(()=>{
    if(isAutomatedBrowser())return;
    const url=new URL(window.location.href);
    const source=url.searchParams.get("utm_source"), medium=url.searchParams.get("utm_medium"),
      campaign=url.searchParams.get("utm_campaign");
    if(source!=="ai_agent" || !["api","mcp"].includes(medium || "") || !campaign || !/^[a-z0-9-]{1,60}$/.test(campaign))return;
    const key=`${url.pathname}|${medium}|${campaign}`;
    const record=()=>{
      if(!getConsent().analytics || isAutomatedBrowser() || landed.has(key))return;
      try { if(sessionStorage.getItem(`bac.agent.landed:${key}`))return; } catch {}
      // Existing track() joins to the current authenticated UUID and queues only
      // consented events until SDK readiness. No identity or new SDK is created.
      track("agent_handoff_landed",{utm_source:"ai_agent",utm_medium:medium as "api"|"mcp",utm_campaign:campaign});
      landed.add(key);
      try {sessionStorage.setItem(`bac.agent.landed:${key}`,"1");}catch{}
    };
    record();
    return subscribeConsent(record);
  },[location]);
}
